<template>
  <a
    class="calculator-action button button--primary"
    :href="redirectUrl"
    data-testid="buynowbutton"
  >
    <slot>{{ $t('calculator.buyNow') }}</slot>
  </a>
</template>

<script>
import UrlGenerator from '@paybis/frontend-common-lib/src/services/url';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'CalculatorBuyNow',
  props: {
    linkParams: { type: Object, required: false, default: {} }
  },
  computed: {
    ...mapState('calculator', [
      'isGuestUser',
      'selectedCryptoCurrency',
      'selectedFiatCurrency',
    ]),
    ...mapGetters('calculator', ['getAvailableCryptoCurrencyByCode']),
    ...mapState('calculator', ['isCorporateAccount', 'defaultBuyLink']),
    redirectUrl () {
      const { links } = this.selectedCryptoCurrency;
      const baseExchangePath = this.isGuestUser ? '' : '/member/exchange';

      if (this.isCorporateAccount) {
        return this.defaultBuyLink;
      }

      const params = {
        ...this.linkParams,
      };

      if (!links?.buy) {
        return UrlGenerator.generate(baseExchangePath || '/', params, this.$i18n.locale);
      }

      const fullPath = `${baseExchangePath}${links.buy}`;

      return UrlGenerator.generate(fullPath, params, this.$i18n.locale);
    },
  },
};
</script>
